import React from "react";
import { Link } from "react-router-dom";
import { ImageWithSkeleton } from "../../../../components/ImageWithSkeleton/ImageWithSkeleton";

const gameProject = 4;

const TopProject = ({ project }) => {
  const {
    id,
    slug,
    img_i,
    title,
    live_site,
    client_side,
    server_side,
    short_desc,
    teaser,
    stack,
  } = project;

  const detailSlug = slug || title.toLowerCase().split(" ").join("").trim();
  const thumbHref =
    id !== gameProject ? client_side || live_site : client_side;
  const thumbTitle =
    id !== gameProject
      ? client_side
        ? "View repository or project"
        : "Open live site"
      : "View repository";

  const teaserText =
    teaser ||
    (short_desc && short_desc.length
      ? short_desc.slice(0, 2).join(" ")
      : "");

  const stackLine =
    stack ||
    (short_desc && short_desc.length ? short_desc[short_desc.length - 1] : "");

  const thumbClassName =
    id === gameProject ? "work-row__thumb work-row__thumb--tall" : "work-row__thumb";

  return (
    <article className="work-row">
      <a
        className="work-row__thumb-wrap"
        href={thumbHref}
        target="_blank"
        rel="noreferrer"
        title={thumbTitle}
      >
        <ImageWithSkeleton
          variant={id === gameProject ? "work-tall" : "work"}
          className={thumbClassName}
          src={img_i}
          alt=""
          loading="lazy"
        />
      </a>
      <div className="work-row__body">
        <h3 className="work-row__title">
          <Link to={`/details/${detailSlug}`}>{title}</Link>
        </h3>
        <p className="work-row__teaser">{teaserText}</p>
        {stackLine ? <p className="work-row__stack">{stackLine}</p> : null}
        <div className="work-row__links">
          {id !== gameProject && live_site ? (
            <a href={live_site} target="_blank" rel="noreferrer">
              Live
            </a>
          ) : null}
          {client_side ? (
            <a href={client_side} target="_blank" rel="noreferrer">
              {id === gameProject ? "Source" : "Code"}
            </a>
          ) : null}
          {id !== gameProject && server_side ? (
            <a href={server_side} target="_blank" rel="noreferrer">
              Backend
            </a>
          ) : null}
          <Link to={`/details/${detailSlug}`}>Case notes</Link>
        </div>
      </div>
    </article>
  );
};

export default TopProject;
